
<template>
  <div id="home">
    <loading v-if="isShowLoading"></loading>
    <Row class="comme_main">
      <Col span="17" :style="{marginRight:'40px'}" >
        <p class="tit">当季推荐  <router-link :to="{name:'ticket'}"  class="more" >更多</router-link></p>
        <hot-season :dataArr="ticketList"></hot-season>
        <p class="tit">热门景点 <router-link  :to="{name:'ticket'}" class="more" >更多</router-link></p>
        <hot-commend :dataArr="ticketList"></hot-commend>
      </Col>
      <Col span="6">
        <p  class="tit"  v-if="isTourname" >旅游卡</p>
        <router-link  v-if="isTourname" :to="{name:'TravelCard'}" class="travelCard" >
          <img  src="./imgs/travelCard.png"  alt="" />
        </router-link>
        <p class="tit">旅游攻略<router-link :to="{name:'travel'}" class="more" >更多</router-link></p>
        <travel-guide :dataArr="strategyList"></travel-guide>
        <p class="tit">新鲜资讯<router-link :to="{name:'information'}" class="more" >更多</router-link></p>
        <!-- isTourname 是否是分销商登录 -->
        <fresh-new :dataArr="information" v-if="isTourname" ></fresh-new>
        <travel-guide :dataArr="information" v-else ></travel-guide>
      </Col>
    </Row>
    <!-- 一起撒欢 -->
     <Row class="comme_main"  >
      <Col span="24"   class="yiqishuan" >
        <div v-if="adPicList.length>0">
          <div  v-for="(item,idx) in adPicList" :key="idx" :style="{marginTop:idx===0?'60px':''}">
            <router-link  :to="{path:item.href,query:{Id:item.adIndex}}" >
              <img :src="item.adPic" alt="" />
            </router-link>
          </div>
        </div>
        <div v-else :style="{marginTop:'20px'}">
          <router-link v-if="isTourname" :to="{name:'TravelCard'}"  >
            <img src="./imgs/yiqisahuan.png" alt="" />
          </router-link> 
          <img  v-else  src="./imgs/yiqisahuan.png"  alt="" />
        </div>   
      </Col>
    </Row>
    <!-- 视频中心 -->
    <Row class="comme_main">
      <p class="tit">视频中心</p>
      <video-center :dataArr="videoList"></video-center>
    </Row>
  </div>
</template>

<script>
import hotSeason from "./components/hotseason.vue";//当季推荐
import hotCommend from "./components/hotCommend.vue";//热门景点
import travelGuide from "./components/travelGuide.vue";//热门景点
import freshNew from "./components/freshNew.vue";//新鲜资讯
import videoCenter from "./components/videoCenter.vue";//视频中心
export default {
  components: {
    hotSeason,
    hotCommend,
    travelGuide,
    freshNew,
    videoCenter
  },
  data () {
    return {
      isShowLoading: false,
      isTourname: sessionStorage.getItem('lgtp') === '02' ? false : true,
      ticketList: [],
      strategyList: [],
      information: [],
      videoList: [],
      picList: [],
      adPicList: []
    }
  },
  watch: {
    '$route': (to) => {
      console.log(to)
    }
  },

  async created () {
    this.IsPC()
    this.gethomeData()
    // this.getadvance()
  },
  methods: {
    /**获取广告位图**/
    getadvance () {
      let queryUrl = `${this.baseURL}/sys/adPosition/v1/shop/`
      queryUrl += '?' + this.QS.stringify({
        // access_token: this.token,
        url: window.location.hostname,
        pageNum: 1,
        pageSize: 10,
        orderBy: 'sort',
        sortIsDown: true
      })
      this.$http.post(queryUrl, { hotelDto: {} }).then(res => {
        let Data = res.data;
        this.isShowLoading = false;
        if (Data.code === 200) {
          this.adPicList = Data.data.items;
        }
      })
    },
    /**
     * 从店铺进来访问景区，当前用户使用PC端访问
     * 还是使用移动端 
      **/
    IsPC () {
      var userAgentInfo = navigator.userAgent;
      var Agents = ["Android", "iPhone", "SymbianOS", "Windows Phone", "iPad", "iPod"];
      var flag = true;
      for (var v = 0; v < Agents.length; v++) {
        if (userAgentInfo.indexOf(Agents[v]) > 0) {
          flag = false;
          break;
        }
      }
      if (!flag) {
        let { fxsId, wxName } = this.$route.query
        window.location.href = `http://${window.location.host}/webchat/?wxName=${wxName}#/home`;
        //window.location.href = `http://${window.location.host}/webchat/?wxName=${wxName}#/distributor?userId=${fxsId}`;
      }
    },
    /**
      * 获取首页相关信息 
      * 获取首页有两个情况：根据query的fsxId来选择获取景区门票还是分销商门票
      * 分别热门推荐、旅游攻略、新鲜资讯、视频中心
      * **/
    async gethomeData () {
      this.isShowLoading = true;
      this.$store.commit('setMenuIndex', '1');
      let realInterface = '';
      let params = null;
      let query = this.$route.query;
      if (Object.keys(query).length && query.fxsId) {
        realInterface = '/ec/distributorShop/v1/queryHomeProductListForDistributor';//分销商
        params = {
          url: window.location.hostname,
          usid: query.fxsId,
          page: 1,
          pageSize: 2
        }
      } else {
        realInterface = '/ec/home/v1/wxTicketSearch';//景点
        params = {
          url: window.location.hostname,
          scenicname: '',
          page: 1,
          pageSize: 2
        }
      }
      const res = await this.$api.all([
        {
          url: this.lee + realInterface,
          type: 'get',
          queryParams: params,
          isToken: false
        },
        {
          url: this.lee + '/ec/home/v1/getHomeStrategy',//旅游攻略、新鲜资讯、视频中心
          type: 'get',
          queryParams: {
            url: window.location.hostname,
            page: 1,
            pageSize: 13
          },
          isToken: false
        }
      ]);
      this.isShowLoading = false
      if (!res) { return false; }
      this.ticketList = res[0].ticketList.items;
      this.strategyList = res[1].strategy.items;//旅游攻略
      this.information = res[1].information.items;//新鲜资讯
      this.videoList = res[1].listVideos;
      console.log(this.ticketList)
    },
  },
}
</script>
<style lang="less" scoped>
@moreColor: #969799;
@hoverColor: #4b7ff0;
.comme_main {
  cursor: default;
  width: 1200px;
  margin: 0 auto;
  // padding: 20px 0;
  .travelCard {
    width: 100%;
    height: 180px;
    img {
      width: 100%;
      height: 100%;
    }
  }
}

//一起撒欢
.yiqishuan {
  width: 100%;
  // margin-top: 40px;
  margin-bottom: 8px;
  img {
    border-radius: 8px;
    height: 260px;
    width: 100%;
  }
}
.tit {
  font-weight: 600;
  font-size: 18px;
  color: #323233;
  margin: 40px 0 20px;
  position: relative;
  .more {
    font-weight: 500;
    font-size: 12px;
    color: @moreColor;
    position: absolute;
    right: 0;
    cursor: pointer;
    &:hover {
      color: @hoverColor;
    }
  }
}
</style>